import React, { useState } from 'react';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import './VideoSection.css';

interface VideoSectionProps {
  isMobile: boolean;
}

const VideoSection: React.FC<VideoSectionProps> = ({ isMobile }) => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const videoId = 'w9bREKlyMq4';
  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}`;
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  const handlePlayClick = () => {
    setIsVideoLoaded(true);
  };

  return (
    <section className={`video-section ${isMobile ? 'video-section--mobile' : 'video-section--desktop'}`}>
      <div className="video-container">
        <LazyLoadComponent threshold={300}>
          {!isVideoLoaded ? (
            <div className="video-placeholder" onClick={handlePlayClick}>
              <img src={thumbnailUrl} alt="Video thumbnail" className="video-thumbnail" />
              <div className="video-play-button">
                <svg width="68" height="48" viewBox="0 0 68 48">
                  <path fill="#fff" fillOpacity="0.8" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"></path>
                  <path fill="#000" d="M 45,24 27,14 27,34"></path>
                </svg>
              </div>
            </div>
          ) : (
            <iframe
              src={embedUrl}
              title="PAX AUTOCRATICA Trailer"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="video-iframe"
            ></iframe>
          )}
        </LazyLoadComponent>
        <p className="video-label">youtube video</p>
      </div>
    </section>
  );
};

export default VideoSection;